import { CrudModel } from "../CrudModel";
import { IStringField, StringField } from "./StringField";

export interface IUrlField extends IStringField {
  fixedPrefix?: string;
  fixedSuffix?: string;
}

export class UrlField extends StringField {
  public static fieldName = "UrlField";
  public static viewComponentName: string = "view-url-field";
  public static formComponentName: string = "form-url-field";
  public static icon = "mdi-link";

  protected _fixedPrefix: string = "";
  protected _fixedSuffix: string = "";

  public get fixedPrefix() {
    if (this._fixedPrefix) {
      return this._fixedPrefix;
    }

    if (this.property && (this.property as any).fixedPrefix) {
      return (this.property as any).fixedPrefix;
    }

    return "";
  }

  public get fixedSuffix() {
    if (this._fixedSuffix) {
      return this._fixedSuffix;
    }

    if (this.property && (this.property as any).fixedSuffix) {
      return (this.property as any).fixedSuffix;
    }

    return "";
  }

  constructor(opts: IUrlField, model: CrudModel) {
    super(opts, model);

    // defaults
    if (typeof opts.cols === "undefined") this.cols = 6;

    if (typeof opts.fixedPrefix !== "undefined")
      this._fixedPrefix = opts.fixedPrefix;
    if (typeof opts.fixedSuffix !== "undefined")
      this._fixedSuffix = opts.fixedSuffix;
  }
}
